// ** Vertical Menu Components
import VerticalNavMenuLink from "./VerticalNavMenuLink"
import VerticalNavMenuGroup from "./VerticalNavMenuGroup"
import VerticalNavMenuSectionHeader from "./VerticalNavMenuSectionHeader"

// ** Store & Actions
import { useDispatch } from 'react-redux'
import { handleLogout } from '@store/authentication'
// ** Utils
import {
  resolveVerticalNavMenuItemComponent as resolveNavItemComponent
} from '@layouts/utils'

const VerticalMenuNavItems = (props) => {
  // ** Store Vars
  const dispatch = useDispatch()
  const user =
    typeof localStorage.getItem("userData") != "undefined"
      ? JSON.parse(localStorage.getItem("userData"))
      : null
  // ** Components Object
  const Components = {
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    VerticalNavMenuSectionHeader
  }
  // ** Render Nav Menu Items
  const RenderNavItems = props.items.map((item, index) => {
    const TagName = Components[resolveNavItemComponent(item)]
    if (user != null) {
      if (user.rol) {
        if (item.rol ? (user.rol.toLowerCase() === item.rol.toLowerCase()) : true) {
          if (item.children) {
            return <TagName item={item} index={index} key={item.id} {...props} />
          }
          return <TagName key={item.id || item.header} item={item} {...props} />
        }
      } else {
        dispatch(handleLogout())
      }
    }
  })
  return RenderNavItems
}

export default VerticalMenuNavItems
